import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  DRIVER_BUS_ASSIGNMENT_PATH,
  NEW_DRIVER_BUS_ASSIGNMENT_PATH,
} from '../../../../config/paths';
import {
  getDriverBusAssignments,
  clearDriverBusAssignments,
  exportFile,
} from '../../../../actions/traffic/DriverBusAssignment';
import { DRIVER_BUS_ASSIGNMENT_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

const DriverBusAssignments = ({
  driverAssignments,
  loading,
  breadcrumbs,
  dispatchGetDriverBusAssignments,
  dispatchClearDriverBusAssignments,
  dispatchExportFile
}) => {

  useEffect(() => () => {
    dispatchClearDriverBusAssignments();
  }, [dispatchClearDriverBusAssignments]);

  const data = driverAssignments.get('content') || [];
  const pages = driverAssignments.get('totalPages') || null;
  const defaultPageSize = driverAssignments.get('size') || DEFAULT_PAGE_SIZE;

  const handleExport = () => {
    dispatchExportFile();
  }

  const extraButtons = (
    <Button onClick={handleExport} color="secondary" className="mr-2">
      <i className="fa fa-file-excel-o mr-2" />
      Exportar
    </Button>
  )

  return (
    <ModuleList
      title="Asignaciones de Conductores"
      buttonPath={NEW_DRIVER_BUS_ASSIGNMENT_PATH}
      extraButtons={extraButtons}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: DRIVER_BUS_ASSIGNMENT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDriverBusAssignments,
        modelPath: DRIVER_BUS_ASSIGNMENT_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDriverBusAssignments: getDriverBusAssignments,
  dispatchClearDriverBusAssignments: clearDriverBusAssignments,
  dispatchExportFile: exportFile
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.DriverUnitHome.get('breadcrumbs'),
    {
      text: 'Asignaciones de Conductores',
      href: DRIVER_BUS_ASSIGNMENT_PATH,
    },
  ],
  driverAssignments: TrafficUnit.DriverBusAssignment.getIn(['all', 'content']),
  loading: TrafficUnit.DriverBusAssignment.getIn(['all', 'loading']),
});

DriverBusAssignments.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  driverAssignments: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDriverBusAssignments: PropTypes.func.isRequired,
  dispatchClearDriverBusAssignments: PropTypes.func.isRequired,
  dispatchExportFile: PropTypes.func.isRequired,
};

DriverBusAssignments.defaultProps = {
  driverAssignments: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DriverBusAssignments);